// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__Zec6A","controls":"Slider_controls__4WzTb","arrow":"Slider_arrow__rwUgu"};